import UploadFileIcon from '@mui/icons-material/UploadFile';
import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';


export const StyledUploadFileIcon = styled(UploadFileIcon)({
  color: COLORS.primary,
  fontSize: '80px',
  alignSelf:'center'
});

export const StyledPDFIcon = styled(PictureAsPdfIcon)({
  color: COLORS.primary,
  fontSize: '80px',
  alignSelf:'center'
});
